// Imported for side effects (module augmentation)
import './occ-cpq-configurator-endpoints.model';
